import React, { useState } from "react";
import toast from "react-hot-toast";
import { updateMember } from "../../services/memberService";

const ChangeStatusForm = ({ member, onClose = () => {} }) => {
  const { memberId, memberName, memberEmail, status: memberStatus } = member;
  const [status, setStatus] = useState(memberStatus);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const { status: responseStatus, message } = await updateMember(memberId, { status });
    if (responseStatus === 200) {
      toast.success(message || "Status updated");
      onClose();
    } else {
      toast.error("Sorry, something went wrong!");
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <h3>Change member status</h3>
        <form onSubmit={handleSubmit}>
          <div className="frm-field">
            <label>Name</label>
            <input type="text" value={memberName} disabled />
          </div>
          <div className="frm-field">
            <label>Email address</label>
            <input type="email" value={memberEmail || "—"} disabled />
          </div>
          <div className="frm-field">
            <label htmlFor="statuses">Status</label>
            <select id="statuses" className="inline-time" style={{ height: 42 }} value={status} onChange={(e) => setStatus(e.target.value)}>
              {["ACTIVE", "INACTIVE", "HIDDEN"].map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn btn-ghost" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={submitting}>{submitting ? "Updating…" : "Update status"}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangeStatusForm;
